<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" :default-href="backButtonDefault" v-if="backButton"></ion-back-button>
      <ion-button router-link="/" v-if="homeButton">
        <ion-icon slot="icon-only" :icon="home"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end" v-if="store.isLoggedIn">
      <ion-button title="Desconectar" @click="logout">
        <ion-icon slot="icon-only" :icon="logOutOutline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</template>

<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue'
import { useRouter } from 'vue-router'
import { IonToolbar, IonTitle, IonButton, IonButtons, IonBackButton, IonIcon } from '@ionic/vue'
import { home, logOutOutline } from 'ionicons/icons'
import { useIncidenciaStore } from '@/stores/incidencia-store'

interface Props {
  title?: string,
  homeButton?: boolean,
  backButton?: boolean,
  backButtonDefault?: string
}

withDefaults(defineProps<Props>(), {
  title: 'Nueva incidencia',
  homeButton: true,
  backButton: true
})

const store = useIncidenciaStore()
const router = useRouter()

const logout = async () => {
  await router.push('/')
  setTimeout(() => {
    store.logout()
    store.resetList()
  }, 300)
}

</script>
